export default __webpack_public_path__ + "static/media/litho-demo-interior-design.aa0a36a7.jpg";